import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LogisticService, BusinesscoItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-invoice-make-overview',
  templateUrl: './invoice-make-overview.component.html',
  styleUrls: ['./invoice-make-overview.component.css']
})
export class InvoiceMakeOverviewComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public itemsListOverviews: Item[] = [];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1756))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadOverviews() {
        if (!this.setting) return;

        return this.itemsListOverviews = await this.datatask.Post(1757, this.setting);
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadOverviews();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadOverviews();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
}
